export enum EChannelName {
  FACEBOOK = 'FACEBOOK',
  GOOGLE_ADS = 'GOOGLE_ADS',
  GOOGLE_ANALYTICS = 'GOOGLE_ANALYTICS',
  ADROLL = 'ADROLL',
  CRITEO = 'CRITEO',
  ALL = 'ALL',
}
